import React, { useState } from "react";

import PaymentModal from "../../components/Modals/PaymentModal";

const Payments = () => {
    const [testModal, setTestModal] = useState(false);
    return (
        <>
            <button className="black" onClick={() => setTestModal(true)}>
                modal test
            </button>
            <PaymentModal isVisible={testModal} setIsVisible={setTestModal} />
        </>
    );
};
export default Payments;
